module.exports = __webpack_public_path__ + "static/media/4.fc545435.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/magazine/4.jpg
// module id = 57
// module chunks = 0